export default __webpack_public_path__ + "static/media/teeers_lowdef.564d5a60.png";